import React from 'react';
import PropTypes from 'prop-types';
import { Select, SelectTrigger, SelectContent, SelectGroup, SelectItem, SelectValue } from 'components/ui/select';

const FilterSelect = ({ label = null, helpText = null, value = null, data = null, onChange = () => {} }) => {
  return (
    <div className="flex flex-col gap-1 mb-2">
      {label && <p>{label}</p>}

      <Select value={value} onValueChange={onChange}>
        <SelectTrigger className="w-full">
          <SelectValue placeholder="Sélectionner..." />
        </SelectTrigger>

        <SelectContent>
          <SelectGroup>
            {data.map((item) => (
              <SelectItem key={item?.value || item?.id} value={item?.value || item?.id}>
                {item?.label || item?.name}
              </SelectItem>
            ))}
          </SelectGroup>
        </SelectContent>
      </Select>
      {helpText && <span className="text-gray-500 text-sm">{helpText}</span>}
    </div>
  );
};

FilterSelect.propTypes = {
  label: PropTypes.string,
  helpText: PropTypes.string,
  value: PropTypes.string,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string,
    })
  ),
  onChange: PropTypes.func,
};

export default FilterSelect;
